export default "__VITE_ASSET__C67VW8OI__"